"use client"

import Link from "next/link"
import { Button } from "@/components/ui/button"
import { ArrowRight, Phone } from "lucide-react"
import { useSettings } from "@/lib/settings-context"

export function CTASection() {
  const { settings } = useSettings()
  const telLink = settings.phoneNumber.replace(/\D/g, '')
  
  return (
    <section className="border-t border-border/40 bg-primary py-16 md:py-20">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mx-auto max-w-3xl text-center">
          <h2 className="mb-4 text-3xl font-bold tracking-tight text-primary-foreground md:text-4xl">
            Ready to Start Your Project?
          </h2>
          <p className="mb-8 text-lg text-primary-foreground/80">
            Get in touch with our team today for a free consultation and quote. We&apos;re ready to bring your infrastructure vision to life.
          </p>
          <div className="flex flex-col items-center justify-center gap-4 sm:flex-row">
            <Button asChild size="lg" className="bg-background text-foreground hover:bg-background/90">
              <Link href="/contact">
                Get Your Free Quote
                <ArrowRight className="ml-2 h-4 w-4" />
              </Link>
            </Button>
            <Button asChild variant="outline" size="lg" className="border-primary-foreground/30 bg-transparent text-primary-foreground hover:bg-primary-foreground/10">
              <a href={`tel:+${telLink}`}>
                <Phone className="mr-2 h-4 w-4" />
                Call Us Now
              </a>
            </Button>
          </div>
        </div>
      </div>
    </section>
  )
}
